import castArray from 'lodash/castArray';
import compact from 'lodash/compact';
import split from 'lodash/fp/split';

/**
 * Receives a string or an array of strings, containing classes separated by any mix of comma or spaces,
 * and an optional prefix to add before each class
 * then returns a list of classes with an optional prefix.
 * @example
 *  getCustomClasses('  class1, class2    class4  ', 'prefix-');
 *  // returns ['prefix-class1', 'prefix-class2', 'prefix-class3']
 * @param classes - string | array of string containing a list of classes
 * @param classPrefix - string prefix to add before each classes
 * @returns list of classes extracted from the string and potentially prefixed
 */

export const getCustomClasses = (classes?: string | string[], classPrefix?: string): string[] =>
    compact(castArray(classes).flatMap(split(/[,\s]+/))).map((cls) => `${classPrefix || ''}${cls}`);
